/**
 * Der ScrollSpy ermöglicht es, Menüpunkt anhand der aktuellen Scrollpositionen
 * als "aktiv" oder "inaktiv" zu markieren.
 *
 * Voraussetzungen:
 * - Das Menü muss data-scrollspy="1" als Attribut enthalten
 * - Alle Menüelemente müssen <a> sein mit einem href auf eine DOM-ID (href="#irgendwas")
 */

var $ = require('jquery');
var _ = require('underscore');


var ScrollSpy = function() {
	_.bindAll(this, "check");

	this.headings = [];

	this.scrollCheck = _.throttle(this.check, 1000 / 3); /* Muss höher als die Dauer der Scroll-Animation sein */
	this.isScrollingSelf = false;
	this.documentHeight = null;
};

/**
 * ScrollSpy für die aktuelle Seite initialisieren.
 */
ScrollSpy.prototype.init = function() {
	/* Alle ScrollSpy Gruppen finden */
	var headings = this.headings;
	var self = this;
	this.documentHeight = $(document).height();

	$('[data-scrollspy]').each(function() {
		/* Alle Links und die jeweiligen Überschriften finden und merken */
		var links = $(this).find('a');
		links.each(function() {
			var link = $(this);
			var target_id = link.attr('href');
			if ( target_id.substring(0, 1) !== "#" ) {
				/* Kein interner Link, ignorieren wir */
				return;
			}
			var target = $(target_id);
			if ( target.length === 0 ) {
				console.log("[ScrollSpy] Ignorie fehlenden Abschnitt " + target_id);
				return;
			}

			/* Klick animieren */
			link.on('click', function(e) {
				e.preventDefault();

				self.isScrollingSelf = true;
				$('html, body').animate({ scrollTop: target.offset().top - 35}, 300, function() {
					self.isScrollingSelf = false;
				});
				if ( typeof history.pushState !== "undefined" ) {
					history.pushState(null, null, target_id);
				}

				self.activate(link);
			});

			var top = target.offset().top;
			headings.push({
				title: link.text(),
				link: link,
				target: target,
				top: top,
				bottom: top + target.outerHeight(true),
			});
		});
	});

	$(window).on('scroll', this.scrollCheck);
	this.check();
};

/**
 * Einen Menüpunkt aktivieren und dabei alle anderen deaktivieren.
 */
ScrollSpy.prototype.activate = function(link) {
	_.each(this.headings, function(item) {
		item.link.removeClass('active');
	});
	link.addClass('active');
};

/**
 * Positionen aller Menüpunkte aktualisieren. 
 * Notwendig wenn etwa durch AJAX/Templates der Inhalt der Seite verändert wurde.
 */
ScrollSpy.prototype.refresh = function(link) {
	_.each(this.headings, function(item) {
		var top = item.target.offset().top;
		item.top = top;
		item.bottom = top + item.target.outerHeight(true);
	});
};

/**
 * Stoppt die Funktionalität des ScrollSpy und entfernt alle Referenzen zu DOM-Elementen.
 */
ScrollSpy.prototype.stop = function() {
	this.headings = [];
	this.documentHeight = null;
	$(window).off('scroll', this.scrollCheck);	
};

/**
 * Prüfung ob sich das Dokument verändert hat und andere Menüpunkte aktiviert werden müssen.
 */
ScrollSpy.prototype.check = function() {
	if ( self.isScrollingSelf ) return;
	if ( this.headings.length === 0 ) return;

	var scrollTop = $(window).scrollTop();
	if ( $(document).height() != this.documentHeight ) {
		console.log("[ScrollSpy] Document height has changed, recalculating all targets");
		this.refresh();
		this.documentHeight = $(document).height();
	}

	if ( scrollTop < 100 ) {
		this.activate(this.headings[0].link);
		return;
	}

	/* Alle Headings durchlaufen und schauen, welches am besten passt */
	var bestMatch = null;
	_.each(this.headings, function(item) {
		if ( scrollTop + 100 > item.top ) {
			bestMatch = item;
		};
	});

	if ( bestMatch ) {
		this.activate(bestMatch.link);
	}
};


module.exports = new ScrollSpy();



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/scrollspy/main.js